export function getData() {
  return JSON.parse(localStorage.getItem('@FACIN/theme:theme'));
}

export function setData(newData) {
  if (newData) localStorage.setItem('@FACIN/theme:theme', JSON.stringify(newData)); // prettier-ignore
}
